import { theme } from '@contrast-security-inc/design-system-foundations'
import { RuleSeverity } from '../../../../components/shared'
import { DrilldownLibrary } from '../../helpers/drilldown-ui-interfaces'

export const getSeverityColor = (severityCode: RuleSeverity) => {
  switch (severityCode) {
    case 'CRITICAL':
      return theme.color.red70
    case 'HIGH':
      return theme.color.orange50
    case 'MEDIUM':
      return theme.color.yellow50
    case 'LOW':
      return theme.color.neutral50
    default:
      return theme.color.neutral50
  }
}

export const isVersionNotWithinRange = (library: DrilldownLibrary) => {
  if (library.policies.versionRestriction) {
    return library.policies.versionRestriction > 0
  }

  return false
}
